import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
    title: 'Application Configurations',
    attributeName: 'mainhubCustomizationAppConfiguration',
    fields: [
        {
            attributeName: 'enableCompositorLayers',
            label: 'Enable Compositor layers',
            helpText: 'Enable or the compositor layers',
            default: true,
            type: FormInputTypes.CHECKBOX,
        }
    ]
}